<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.34375 11C0.34375 5.39086 4.89086 0.84375 10.5 0.84375C16.1091 0.84375 20.6562 5.39086 20.6562 11C20.6562 16.6091 16.1091 21.1562 10.5 21.1562C4.89086 21.1562 0.34375 16.6091 0.34375 11ZM7.375 7.09375C6.94353 7.09375 6.59375 7.44353 6.59375 7.875V14.125C6.59375 14.5565 6.94353 14.9062 7.375 14.9062H8.15625C8.58772 14.9062 8.9375 14.5565 8.9375 14.125V7.875C8.9375 7.44353 8.58772 7.09375 8.15625 7.09375H7.375ZM12.8438 7.09375C12.4123 7.09375 12.0625 7.44353 12.0625 7.875V14.125C12.0625 14.5565 12.4123 14.9062 12.8438 14.9062H13.625C14.0565 14.9062 14.4062 14.5565 14.4062 14.125V7.875C14.4062 7.44353 14.0565 7.09375 13.625 7.09375H12.8438Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPauseCircle',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>